import React, { useEffect } from 'react';
import { useApp } from 'react-admin-base';
import { LanguageSwitcher } from 'react-admin-base-bootstrap';
import { Col, Container, Row } from 'reactstrap';
import { useThemeOptions } from '../ThemeOptions';
import Themes from '../Themes';
export default function Layout({ children }) {
    const app = useApp();
    const options = useThemeOptions();
    const logo = (app.logo || app.onlylogo) && React.createElement("img", { className: "w-75 mb-5", src: app.logo || app.onlylogo, alt: app.name });
    useEffect(function () {
        document.body.className = "auth-body-bg" + (options.theme ? ' fixed-theme-' + options.theme : '');
    }, [options]);
    return React.createElement(Themes, null,
        React.createElement("div", null,
            React.createElement(Container, { fluid: true, className: "p-0" },
                React.createElement(Row, { className: !!options.noLoginBanner ? 'g-0 justify-content-center' : 'g-0' },
                    React.createElement(Col, { lg: !options.noLoginBanner ? "4" : "5" },
                        React.createElement("div", { className: "authentication-page-content p-4 d-flex align-items-center min-vh-100" },
                            React.createElement("div", { className: "w-100" },
                                React.createElement(Row, { className: "justify-content-center" },
                                    React.createElement("div", { className: "col-lg-9" },
                                        React.createElement("div", null,
                                            React.createElement("div", { className: "text-center" },
                                                logo,
                                                !app.logo && React.createElement("h4", { className: "font-size-18 mt-4" }, app.name)),
                                            children,
                                            React.createElement("div", { className: "mt-3" },
                                                React.createElement(LanguageSwitcher, null)))))))),
                    !options.noLoginBanner && React.createElement(Col, { lg: "8" },
                        React.createElement("div", { className: "authentication-bg" },
                            React.createElement("div", { className: "bg-overlay" })))))));
}
